<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext, getPreviousStepId } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_military_fleets')
}

const isOnCommandSection = computed(() => {
  return route.path.startsWith('/command/fleets')
})

const goToCommand = () => {
  router.push('/command/fleets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/military.webm"
  >
    <template #text>
      <p class="pb-2">
        Fleets are groups of ships that travel and fight together as a single unit.
      </p>
      <p class="pb-2">
        Managing fleets is essential for coordinating large-scale military operations.
      </p>
      <p class="pb-3">
        There are 2 types of groups in any fleet, the <span class="text-blue-500">Core fleet</span>, which is executing the current actions set for the fleet.
        And the <span class="text-yellow-500">reinforcements</span>, these are the ships that are catching up to the core of the fleet.
      </p>
      <p class="pb-3">
        It’s common to have fleets on active missions while planets continue building ships that automatically join the fleet once completed.
      </p>
      <p class="pb-3">
        I'll come back to fleets later, when we have met some civilizations.
      </p>

    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnCommandSection" @click="goToCommand" class="mr-2">
        Go to Fleets
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Continue
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>